var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M6.2 19.8l56.8-5.3c4.5-.4 6.7 1.8 8.1 4.7l17.8 28.5c1.4 2.3 1.6 4.9.4 6.9L72.8 85.8c-2 3.1-5.7 4.1-9.9 4.3L8.8 95.3c-4.9.3-7.5-2.2-7.5-6.8V26.2c0-4.3 2.1-6.1 4.9-6.4zm55.3 4.9c-.8-.7-2.3-.9-4.1-.7L16.2 27.8c-1.8.2-2.3 1.1-2.3 2.5v53.9c0 1.6.9 2.5 2.5 2.3l43.2-3.8c1.8-.2 2.7-1.4 2.7-2.9V26c0-.9-.3-1.1-.8-1.3zm19.9 29.5L67.6 31.9c-.6-.9-1.2-1.3-2.3-1.1L64 31v47.7c.9.2 1.6.4 2.3-.2l15.1-22.3c.7-1.1.7-1.6 0-2zm-58.4-19l26.6-2.5c.8-.1 1.2.3 1.4.9l.4 2.3c.1.6-.3 1-1.1 1.1l-6.8.6v38.9l8.3-.8c.8-.1 1.2.3 1.4.9l.4 2.3c.1.6-.3 1-1.1 1.1l-28.7 2.7c-.8.1-1.2-.3-1.4-.9l-.4-2.3c-.1-.6.3-1 1.1-1.1l7.5-.7V37.4l-7.5.7c-.8.1-1.2-.3-1.4-.9l-.4-2.3c-.1-.6.3-1 1.1-1.1l8.3-.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotion);
export default __webpack_public_path__ + "static/media/notion.9535a12b652aab39a302167d86a555bf.svg";
export { ForwardRef as ReactComponent };